export default __webpack_public_path__ + "static/media/settings-outline.75396f40.svg";